import { mergePromoCodeMeta, type PromoCodeMeta } from './promo-code.ts'

const UTM_PARAM_MAX_LENGTH = 128

export function sanitizeUtmParam(value: string | null | undefined): string {
  if (!value) {
    return ''
  }
  const trimmed = value.trim().slice(0, UTM_PARAM_MAX_LENGTH)
  return trimmed
    .replace(/[\x00-\x1f\x7f]/g, '')
    .replace(/[<>'"`]/g, '')
}

export function buildUtmMetaFromSearchParams(
  params: URLSearchParams,
  landingPage: string,
): PromoCodeMeta | null {
  const utm_campaign = sanitizeUtmParam(params.get('utm_campaign')) || null
  const utm_source = sanitizeUtmParam(params.get('utm_source')) || null
  const utm_medium = sanitizeUtmParam(params.get('utm_medium')) || null
  const utm_officer = sanitizeUtmParam(params.get('utm_officer')) || null
  const utm_referrer = sanitizeUtmParam(params.get('utm_referrer')) || null

  if (!utm_campaign && !utm_source && !utm_medium && !utm_officer && !utm_referrer) {
    return null
  }

  return {
    source: 'utm',
    landing_page: landingPage,
    utm_campaign,
    utm_medium,
    utm_source,
    utm_officer,
    utm_referrer,
    captured_at: new Date().toISOString(),
  }
}

export function captureUtmParamsFromWindow(): void {
  if (typeof window === 'undefined') {
    return
  }

  try {
    const url = new URL(window.location.href)
    const utmMeta = buildUtmMetaFromSearchParams(url.searchParams, url.pathname)
    if (utmMeta) {
      mergePromoCodeMeta(utmMeta)
    }
  } catch {
    // Ignore malformed URLs and storage failures.
  }
}
